import React from 'react';
import { Col, Container, Row } from 'shards-react';
import MainSidebar from '../MainSidebar/MainSidebar';

const DefaultLayout = ({ children }) => {
  return (
    <Container fluid>
      <Row>
        <MainSidebar />

        <Col
          className='main-content p-0'
          lg={{ size: 10, offset: 2 }}
          md={{ size: 10, offset: 2 }}
          sm='12'
          tag='main'
        >
          {children}
        </Col>
      </Row>
    </Container>
  );
};

export default DefaultLayout;
